import { closeAction } from 'components/core/task/send_reminder/actions'
import reducer, { SendRemindersState } from 'components/core/task/send_reminder/reducer'
import { SendReminderFormData, SendReminderView } from 'components/core/task/send_reminder/SendReminderView'
import { useAlert } from 'hooks/useAlert'
import { sendCampaignReminder } from 'lib/actions/access_review'
import { useClientRPC } from 'lib/rpcts'
import { AccessReviewActionsServiceClient } from 'pbts/c1/api/accessreview/v1/accessreview_actions.client'
import { FC, useEffect, useMemo, useReducer } from 'react'
import { useIntl } from 'react-intl'

export type SendCampaignReminderProps = {
    accessReviewID: string
    onClose: () => void
}

export const SendCampaignReminder: FC<SendCampaignReminderProps> = ({ accessReviewID, onClose }) => {
    const intl = useIntl()
    const arActionSvc = useClientRPC<AccessReviewActionsServiceClient>(AccessReviewActionsServiceClient)
    const [state, dispatch] = useReducer(reducer, new SendRemindersState())
    const alert = useAlert()

    useEffect((): void => {
        if (!state.sent) return
        alert(
            intl.formatMessage({
                id: 'components_core_send_reminders_sent_alert',
                defaultMessage: 'Reminder sent.',
            }),
            'success',
        )
        dispatch({ type: closeAction })
    }, [state, intl, alert])

    useEffect((): void => {
        if (state.open) return
        onClose()
    }, [state, onClose])

    const accessReviewLink = useMemo(() => {
        if (typeof window === 'undefined' || !accessReviewID) return undefined
        return `${window.location.origin}/assignments/reviews/${accessReviewID}`
    }, [accessReviewID])

    if (!accessReviewID) return null

    const handleSubmit = (data: SendReminderFormData): void => {
        sendCampaignReminder(dispatch, arActionSvc, accessReviewID, data.notifyManager, data.message)
    }

    const handleClose = (): void => dispatch({ type: closeAction })

    return <SendReminderView
        open={state.open}
        onClose={handleClose}
        hasReceivers={state.hasReceivers}
        canShowManager={false}
        canCCOthers={false}
        onSubmit={handleSubmit}
        accessReviewLink={accessReviewLink}
    />
}
